import { gql } from '@apollo/client/core';

export const removeMemberUser = gql`
  mutation removeMemberFromOrganization($input: MemberToOrganizationInput!) {
    admin {
      removeMemberFromOrganization(where: $input) {
        code
        adviseMessage {
          code
          description
        }
      }
    }
  }
`;
